import React, {useEffect} from 'react'
import { Link } from 'react-router-dom';

const Unauthorized = () => {  
    useEffect(() => {
      document.body.style.backgroundColor = "#fff";
    }, []);
  return (
    <div className="customErrorWrapper">
      <div className="serverError"></div>
      <div className="goBackLink">
        <p>Unauthorized</p>
        <p>Please close this window and retry launching the application.</p>        
      </div>
    </div>
  )
}

export default Unauthorized